// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { State } from '@app/access-management/state';
import { Observable, of } from 'rxjs';
import { selectGroups } from './groups.selectors';
import { needsLoading, LoadingStatus, GoAction, QueueAlertAction, AlertType } from '@app/core';
import { take, filter, map } from 'rxjs/operators';
import { LoadingGroupsAction, RemoveGroupByIdAction } from './groups.actions';
import { SelectGroupAction } from '../group-details/group-details.actions';
import { GroupsState } from './groups.reducer';

@Injectable({providedIn: 'root'})
export class GroupFacadeService {

    groups$ = of();
    loading$: Observable<boolean> = of();
    loaded$: Observable<boolean> = of();
    loadFailed$: Observable<boolean> = of();
    groupState$ = of();

    constructor(private store: Store<State>) {}

    initializeGroup () {
        this.groupState$ = this.store.pipe(select(selectGroups));
         this.groupState$.pipe(
            take(1),
            filter((items) => needsLoading(items)))
            .subscribe(() => this.store.dispatch(new LoadingGroupsAction()));

        this.groups$ = this.groupState$.pipe(
            filter((items) => !needsLoading(items)),
            map((state: GroupsState) => state.data));

        this.loading$ = this.groups$.pipe(map((groups: GroupsState) => groups.status === LoadingStatus.LOADING));
        this.loaded$ = this.groups$.pipe(map((groups: GroupsState) => groups.status === LoadingStatus.LOAD_COMPLETE));
        this.loadFailed$ = this.groups$.pipe(map((groups: GroupsState) => groups.status === LoadingStatus.LOAD_FAILED));
    }

    selectGroup (row: any) {
        this.store.dispatch(new SelectGroupAction(row));
    }

    removeGroup (removedId: string) {
        this.store.dispatch(new RemoveGroupByIdAction(removedId));
    }

    goToGroupDetail(row: any) {
        this.store.dispatch(new SelectGroupAction(row));
        this.store.dispatch(new GoAction(['/iam/groups', row.group_id]));
    }

    goToEditGroup (row: any) {
        this.store.dispatch(new SelectGroupAction(row));
        this.store.dispatch(new GoAction(['/iam/groups', row.group_id, 'edit']));
    }

    removeGroupSucceed (removeId: string) {
        this.store.dispatch(new RemoveGroupByIdAction(removeId));
        this.store.dispatch(new QueueAlertAction({ alertText: `Group delete succeed.`, alertType: AlertType.SUCCESS }));
    }

    removeGroupFailed () {
        this.store.dispatch(new QueueAlertAction({ alertText: `Group delete failed.`, alertType: AlertType.ERROR }));
    }


}




// WEBPACK FOOTER //
// ./src/app/access-management/state/groups/group.facade.ts